import type { TFunction } from "i18next";

import { buildAnmSections } from "@modules/admin";

/**
 * Colunas EC (k..o) do Quadro 3 da ANM. O step `conservationState` da ficha
 * reaproveita exatamente a grade da Classificação ANM do Admin (form §4).
 */
export interface InspectionEcColumn {
  /** Chave da coluna no catálogo ANM (`ec-k`…`ec-o`). */
  key: string;
  letter: string;
  title: string;
  options: { score: number; text: string }[];
  /** Chave usada no `itemKey` da ficha (`conservationState.ecK`). */
  responseKey: string;
}

/** `ec-k` → `ecK` (chave usada em `itemKey` / `selections[].columnKey`). */
export const toEcResponseKey = (columnKey: string) => {
  const [, letter] = columnKey.split("-");
  return `ec${(letter ?? "").toUpperCase()}`;
};

export const buildInspectionEcColumns = (
  translate: TFunction,
): InspectionEcColumn[] => {
  const grade = buildAnmSections(translate)
    .flatMap((section) => section.grades)
    .find((candidate) => candidate.key === "ec");

  return (grade?.columns ?? []).map((column) => ({
    key: column.key,
    letter: column.letter,
    title: column.title,
    options: column.options,
    responseKey: toEcResponseKey(column.key),
  }));
};

export const INSPECTION_EC_ITEM_KEY_PREFIX = "conservationState";

export const ecItemKey = (responseKey: string) =>
  `${INSPECTION_EC_ITEM_KEY_PREFIX}.${responseKey}`;

/** Nota 10 em qualquer coluna exige inspeção especial (form §4.1). */
export const EC_SPECIAL_INSPECTION_SCORE = 10;
